import { z } from "zod";

// POST /teams/:teamId/publications body schema.
// `content` is free-text; no length cap enforced beyond Prisma @db.Text.
// `event_id` must be an event the team is participating in -- the route
// enforces that lookup; this schema only checks shape.
export const createTeamPublicationSchema = z.object({
  event_id: z.string().min(1, "event_id is required"),
  content: z.string().min(1, "content cannot be empty"),
});

export type CreateTeamPublicationInput = z.infer<typeof createTeamPublicationSchema>;
